import ArchivioVideo from './ArchivioVideo';

export default ArchivioVideo;
